































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { SidebarConfig, sidebarConfig } from '@/config/sidebar';

@Component<CSideBar>({})
export default class CSideBar extends Vue {
  @Prop({ type: Boolean })
  value: boolean;

  sidebarConfig: SidebarConfig = sidebarConfig;

  get containerComponent() {
    return this.$vuetify.breakpoint.mobile ? 'v-drawer' : 'div';
  }
}
